// Regras do indicador de execucao da lista de conversas (User Story 3,
// specs/execution_progress/).
//
// O campo `status` de uma sessao carrega DOIS significados diferentes, e e'
// isso que justifica as duas funcoes daqui morarem fora do componente:
//
//   'processing'          -> ESTADO: existe execucao viva no servidor agora.
//                            Vem do banco, em /post_list_session.
//   'completed' | 'error' -> NOTIFICACAO: a execucao fechou e o usuario ainda
//                            nao viu. So' existe no cliente, escrita pelo poll
//                            de /post_generation_status, e some ao abrir a
//                            conversa.
//
// Confundir os dois foi o bug original: abrir a conversa apagava tambem o
// 'processing', e como o unico lugar que sabia reescreve-lo era o reader do
// SSE (ja' cancelado na primeira saida), sair da conversa uma segunda vez nao
// acendia mais bolinha nenhuma.

// Funde a lista recem-lida do servidor com o estado local anterior.
//
// O servidor VENCE quando reporta status, porque so' ele sabe se a execucao
// ainda esta viva (e o `interrupted` derivado do heartbeat ja' vem resolvido
// de la'). Ausencia de status no servidor NAO e' "apague o que voce tem":
// /post_list_session so' reporta execucao viva, entao a notificacao de
// resultado pronto - que nao existe no banco - precisa sobreviver ao refetch.
export function fundirStatusDeExecucao(listaDoServidor, sessoesAnteriores) {
  return listaDoServidor.map(item => {
    if (item.status) return item;
    const anterior = (sessoesAnteriores || []).find(s => s.session_id === item.session_id);
    return anterior && anterior.status ? { ...item, status: anterior.status } : item;
  });
}

// Aplica a resposta do poll de /post_generation_status.
//
// `interrupted` APAGA o indicador em vez de virar mais um estado visivel: nao
// houve resultado, entao nao ha' notificacao a dar. O estado honesto da
// mensagem morta e' assunto de dentro da conversa (T059), e manter a bolinha
// giraria pra sempre - generation_status nao fecha sozinho quando um deploy
// derruba a execucao.
export function aplicarStatusDoPoll(sessoes, statuses) {
  return sessoes.map(s => {
    const doServidor = statuses[s.session_id];
    if (!doServidor || !doServidor.status || doServidor.status === s.status) return s;
    if (doServidor.status === 'interrupted') return { ...s, status: undefined };
    return { ...s, status: doServidor.status };
  });
}

// Abrir a conversa responde "ja' terminou?" - mas nao termina nada. So' o
// status de NOTIFICACAO e' consumido aqui; uma execucao em andamento continua
// marcada, e a bolinha some sozinha quando o servidor parar de reporta-la.
export function limparIndicadorDeSessaoVista(sessoes, sessionId) {
  return sessoes.map(s =>
    s.session_id === sessionId && s.status && s.status !== 'processing'
      ? { ...s, status: undefined }
      : s
  );
}
